import { state } from '../lib/state.js';
import { drawRoute } from '../ui/map.js';
import { els } from '../app/dom.js';
import { isSupabaseConfigured } from '../config.js';
import { renderPoints } from '../routes/route-editor.js';
import { renderRoutes } from '../routes/route-list.js';
import { renderSections } from '../calculators/orchestrator.js';
import { renderResults } from '../calculators/result-handler.js';
import { syncHeaderFields } from '../routes/route-actions.js';
import { pointsForCurrentView, getRoutePlanPoints, isRouteConstraint } from '../routes/route-plan.js';
import { round, formatDuration, hasCoords } from '../lib/app-helpers.js';

export function renderAll(){
  syncHeaderFields(false);
  renderPoints();
  renderSections();
  renderResults();
  renderRoutes();
  updateButtons();
  const viewPoints = pointsForCurrentView();
  if(viewPoints.length) {
    const routeForMap = state.currentRoute.pointEditMode && state.currentRoute.routeEditPreview
      ? { ...state.currentRoute.routeEditPreview, originalPoints:viewPoints, expandedPoints:[] }
      : (state.currentRoute.expandedPoints?.length
        ? state.currentRoute
        : { ...state.currentRoute, originalPoints:viewPoints, expandedPoints:[] });
    drawRoute(routeForMap);
  }
}


export function updateButtons(){
  const plan=getRoutePlanPoints(state.currentRoute);
  const stops=plan.filter(point=>!isRouteConstraint(point));
  const missing=plan.filter(point=>!hasCoords(point)).length;
  const calculated=Boolean(state.currentRoute.expandedPoints?.length&&state.currentRoute.routeGeometry);
  const hasPreviewGeometry=Boolean(
    state.currentRoute.routeGeometry
    || state.currentRoute.routeEditPreview?.routeGeometry
  );

  els.resolvePointsBtn.disabled=!missing;
  els.analyzeRouteBtn.disabled=stops.length<2;
  els.reversePointsBtn.disabled=plan.length<2;
  const loginRequired = Boolean(isSupabaseConfigured && !state.session?.access_token);
  const hasSections=Boolean(state.currentRoute.sections.length);
  const routeSaved=Boolean(state.currentRoute.id);
  const routeDirty=Boolean(state.currentRoute.dirty);
  els.saveRouteBtn.disabled=!hasSections||loginRequired;
  els.saveRouteBtn.textContent=loginRequired
    ? 'Zaloguj się, aby zapisać'
    : (routeSaved?'Zapisz zmiany':'Zapisz linię');
  els.saveRouteBtn.className=`button route-save-button ${routeSaved&&!routeDirty?'is-saved':'is-unsaved'}`;
  els.saveRouteBtn.title=loginRequired
    ? 'Dane w Supabase są dostępne wyłącznie po zalogowaniu.'
    : (routeSaved&&!routeDirty?'Linia jest zapisana.':'Zapisz aktualny stan linii.');
  if(els.runAllCalculatorsBtn){
    els.runAllCalculatorsBtn.disabled=loginRequired||!routeSaved||routeDirty||!hasSections;
    els.runAllCalculatorsBtn.title=!routeSaved
      ?'Najpierw zapisz linię.'
      :routeDirty
        ?'Najpierw zapisz zmiany linii.'
        :'Uruchom po kolei wszystkie kalkulatory tej linii z zapisanymi parametrami.';
  }
  els.exportReportBtn.disabled=!hasSections;
  if(els.openMapPreviewBtn)els.openMapPreviewBtn.disabled=!hasPreviewGeometry;
  if(els.editPointsBtn){
    els.editPointsBtn.classList.toggle('hidden',!calculated);
    els.editPointsBtn.disabled=!calculated;
  }
  const savedAndDirty=Boolean(state.currentRoute.id&&state.currentRoute.dirty);
  els.routeStateBadge.textContent=savedAndDirty?'Niezapisane zmiany':state.currentRoute.id?'Linia zapisana':(stops.length?'Niezapisana':'Nowa linia');
  els.routeStateBadge.className=`badge ${savedAndDirty?'warning':state.currentRoute.id?'ok':stops.length?'warning':'neutral'}`;

  if(state.currentRoute.pointEditMode){
    const constraints=plan.filter(isRouteConstraint).length;
    els.mapSummary.textContent=`Edycja przebiegu · ${plan.length} punktów · ${constraints} punktów wymuszających. Po zmianach przelicz trasę.`;
  }else{
    els.mapSummary.textContent=state.currentRoute.routeGeometry
      ? `${round(state.currentRoute.distanceMeters/1000)} km · ${formatDuration(state.currentRoute.durationSeconds)} · połączona trasa GPS/OSRM`
      : 'Trasa nie została wyznaczona.';
  }
}
